import { useTheme as useThemeMui } from '@mui/material';
import { Theme } from '@componentLibraryWrapper/theme';

export const useTheme = () : Theme => {
  const theme = useThemeMui();

  return theme;
}